"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _ImageState = _interopRequireDefault(require("../ImageState.js"));

var _Observable = _interopRequireDefault(require("../Observable.js"));

var _State = _interopRequireDefault(require("../source/State.js"));

var _util = require("../util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/renderer/Layer
 */


/**
 * @template {import("../layer/Layer.js").default} LayerType
 */
var LayerRenderer =
/** @class */
function (_super) {
  __extends(LayerRenderer, _super);
  /**
   * @param {LayerType} layer Layer.
   */


  function LayerRenderer(layer) {
    var _this = _super.call(this) || this;
    /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */


    _this.ready = true;
    /** @private */

    _this.boundHandleImageChange_ = _this.handleImageChange_.bind(_this);
    /**
     * @protected
     * @type {LayerType}
     */

    _this.layer_ = layer;
    /**
     * @type {import("../render/canvas/ExecutorGroup").default}
     */

    _this.declutterExecutorGroup = null;
    return _this;
  }
  /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
   * an array of features.
   */


  LayerRenderer.prototype.getFeatures = function (pixel) {
    return (0, _util["abstract"])();
  };
  /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */


  LayerRenderer.prototype.getData = function (pixel) {
    return null;
  };
  /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */


  LayerRenderer.prototype.prepareFrame = function (frameState) {
    return (0, _util["abstract"])();
  };
  /**
   * Render the layer.
   * @abstract
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */


  LayerRenderer.prototype.renderFrame = function (frameState, target) {
    return (0, _util["abstract"])();
  };
  /**
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */


  LayerRenderer.prototype.loadedTileCallback = function (tiles, zoom, tile) {
    if (!tiles[zoom]) {
      tiles[zoom] = {};
    }

    tiles[zoom][tile.tileCoord.toString()] = tile;
    return undefined;
  };
  /**
   * Create a function that adds loaded tiles to the tile lookup.
   * @param {import("../source/Tile.js").default} source Tile source.
   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
   * @protected
   */


  LayerRenderer.prototype.createLoadedTileFinder = function (source, projection, tiles) {
    return (
      /**
       * @param {number} zoom Zoom level.
       * @param {import("../TileRange.js").default} tileRange Tile range.
       * @return {boolean} The tile range is fully loaded.
       * @this {LayerRenderer}
       */
      function (zoom, tileRange) {
        var callback = this.loadedTileCallback.bind(this, tiles, zoom);
        return source.forEachLoadedTile(projection, zoom, tileRange, callback);
      }.bind(this)
    );
  };
  /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */


  LayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
    return undefined;
  };
  /**
   * @abstract
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
   *    location, null will be returned.  If there is data, but pixel values cannot be
   *    returned, and empty array will be returned.
   */


  LayerRenderer.prototype.getDataAtPixel = function (pixel, frameState, hitTolerance) {
    return null;
  };
  /**
   * @return {LayerType} Layer.
   */


  LayerRenderer.prototype.getLayer = function () {
    return this.layer_;
  };
  /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */


  LayerRenderer.prototype.handleFontsChanged = function () {};
  /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */


  LayerRenderer.prototype.handleImageChange_ = function (event) {
    var image =
    /** @type {import("../Image.js").default} */
    event.target;

    if (image.getState() === _ImageState["default"].LOADED) {
      this.renderIfReadyAndVisible();
    }
  };
  /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../ImageBase.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */


  LayerRenderer.prototype.loadImage = function (image) {
    var imageState = image.getState();

    if (imageState != _ImageState["default"].LOADED && imageState != _ImageState["default"].ERROR) {
      image.addEventListener(_EventType["default"].CHANGE, this.boundHandleImageChange_);
    }

    if (imageState == _ImageState["default"].IDLE) {
      image.load();
      imageState = image.getState();
    }

    return imageState == _ImageState["default"].LOADED;
  };
  /**
   * @protected
   */


  LayerRenderer.prototype.renderIfReadyAndVisible = function () {
    var layer = this.getLayer();

    if (layer.getVisible() && layer.getSourceState() == _State["default"].READY) {
      layer.changed();
    }
  };
  /**
   * Clean up.
   */


  LayerRenderer.prototype.disposeInternal = function () {
    delete this.layer_;

    _super.prototype.disposeInternal.call(this);
  };

  return LayerRenderer;
}(_Observable["default"]);

var _default = LayerRenderer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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